import { ErrorBoundary } from "@/shared/components/ErrorBoundary";
import { AppProviders } from "./AppProviders";
import { AppRouter } from "./AppRouter";

if (import.meta.env.VITE_APP_ENV === "dev") {
  console.log("Running dev locally");
} else if (import.meta.env.VITE_APP_ENV === "staging") {
  console.log("Running staging");
} else if (import.meta.env.VITE_APP_ENV === "production") {
  console.log("Running production");
} else {
  console.log("Running unknown environment");
}

const App = () => {
  return (
    <ErrorBoundary>
      <AppProviders>
        <AppRouter />
      </AppProviders>
    </ErrorBoundary>
  );
};

export default App;
